export function getSchoolGeneralAchievementCardsProgress({ intelligence_id }: Object) {
  return {
    type: 'REQUEST_SCHOOL_GENERAL_ACHIEVEMENT_CARDS_PROGRESS',
    payload: {
      intelligence_id
    }
  };
}
